/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const ON_HORIZONTAL_KEY_PRESS_FILTERED_GUIDE = 'ON_HORIZONTAL_KEY_PRESS_FILTERED_GUIDE';
export const ON_VERTICAL_KEY_PRESS_FILTERED_GUIDE = 'ON_VERTICAL_KEY_PRESS_FILTERED_GUIDE';
export const ON_KEY_OK_FILTERED_GUIDE = 'ON_KEY_OK_FILTERED_GUIDE';
export const ON_SET_VERTICAL_POSITION_FILTERED_GUIDE = 'ON_SET_VERTICAL_POSITION_FILTERED_GUIDE';
export const ON_SET_HORIZONTAL_POSITION_FILTERED_GUIDE =
    'ON_SET_HORIZONTAL_POSITION_FILTERED_GUIDE';
